<template>
  <div class="app">
    <!-- ================= 视图一：1分购专区 ================= -->
    <section class="view" :class="{ active: currentView === 'zone' }">
      <header class="topbar" style="display:none;">
        <div class="brand">
          <span class="brand-name">银联卡礼遇</span>
          <span class="brand-tag">1分购</span>
        </div>
        <!-- 新增：活动细则按钮 -->
        <button class="rule-btn" @click="openRuleModal">活动细则</button>
      </header>
      <div class="hero">
        <span class="hero-badge">
          <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2 4 5.5v5.6c0 5 3.4 9.4 8 10.9 4.6-1.5 8-5.9 8-10.9V5.5L12 2z"/></svg>
          银联卡礼遇 · 持卡人专属
        </span>
        <!-- ========== 新增：右上角活动细则按钮（放到红框位置） ========== -->
        <button class="hero-rule-btn" @click="openRuleModal">活动细则</button>

        <div class="hero-main">
          <h1 class="hero-title">一分钱<br><span class="hl">好礼送到家</span></h1>
          <div class="hero-price"><small>限时特惠</small><b>¥0.01</b><span>起</span></div>
        </div>
        <p class="hero-sub">云闪付支付 · 每日限量 · 先到先得</p>
      </div>

      <main class="product-list" aria-live="polite">
        <article
          v-for="product in products"
          :key="product.id"
          class="pcard"
          :class="{ sold: product.stock <= 0 }"
          :data-cat="product.cat"
          :data-id="product.id"
        >
          <div class="pimg">
            <img :src="product.img" :alt="product.name">
            <span v-if="product.stock <= 0" class="psold-badge">已售罄</span>
          </div>
          <div class="pinfo">
            <h3 class="pname">{{ product.name }}</h3>
            <div class="pprice">
              <span class="price-now"><small>¥</small>{{ product.price.toFixed(2) }}</span>
              <span class="price-orig">¥{{ product.orig }}</span>
            </div>
            <div v-if="product.stock <= 0" class="pstock">已售罄</div>
            <div v-else-if="product.stock <= 10" class="pstock low">仅剩 {{ product.stock }} 件</div>
            <div v-else class="pstock">库存 {{ product.stock }} 件</div>
          </div>
          <button
            class="btn-buy"
            :class="{ disabled: product.stock <= 0 }"
            :disabled="product.stock <= 0"
            @click.stop="buyProduct(product.id)"
          >
            {{ product.stock <= 0 ? '已售罄' : '立即购买' }}
          </button>
        </article>
      </main>
      <section class="faq" :class="{ open: faqOpen }">
        <button class="faq-head" :aria-expanded="faqOpen ? 'true' : 'false'" @click="toggleFaq">
          <span>活动说明</span>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>
        </button>
        <div class="faq-body">
          <dl class="faq-item"><dt>特别说明</dt><dd>购买成功,使用权益平台下单手机号登录甲子商城,在我的-我的订单-可查看订单发货进度与售后</dd></dl>
          
          <dl class="faq-item"><dt>配送说明</dt><dd>商品由合作商家包邮发货，一般 1-3 个工作日送达。</dd></dl>
          <dl class="faq-item"><dt>客服电话</dt><dd>400-998-9999。</dd></dl>
        </div>
      </section>
      <footer class="legal">
        本活动由银联卡礼遇合作商户北京甲子科技提供<br>
      </footer>
    </section>

    <!-- ================= 视图二：收货地址 + 支付 ================= -->
    <section class="view" :class="{ active: currentView === 'address' }">
      <header class="topbar">
        <button class="icon-btn" aria-label="返回专区" @click="goToZone">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M19 12H5"/><path d="m12 19-7-7 7-7"/>
</svg>

        </button>
        <h1 class="topbar-title">确认收货地址</h1>
        <span class="topbar-spacer"></span>
      </header>
      <div class="steps" aria-label="支付流程">
        <div class="step done"><i>1</i><span>选购商品</span></div>
        <div class="step-line done"></div>
        <div class="step active"><i>2</i><span>填写地址</span></div>
        <div class="step-line"></div>
        <div class="step"><i>3</i><span>确认支付</span></div>
      </div>
      <div class="cd-bar" v-if="order_sn && countdown > 0">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9.2"/><path d="M12 7v5l3.2 2"/></svg>
        <span>剩余时间</span><b>{{ countdownText }}</b><span>超时自动取消</span>
      </div>
      <section class="order-card" v-if="curProduct">
        <h2>已选商品</h2>
        <div class="order-row">
          <div class="order-img"><img :src="getProductImg(curProduct.id)" :alt="curProduct.name"></div>
          <div class="order-info">
            <div class="order-name">{{ curProduct.name }}</div>
            <div class="order-spec">数量 ×1</div>
          </div>
          <div class="order-price">
            <span class="now"><small>¥</small>{{ curProduct.price.toFixed(2) }}</span>
            <span class="orig">¥{{ curProduct.orig }}</span>
          </div>
        </div>
        <div class="order-meta">
          <div class="row"><span>商品金额</span><b>¥{{ curProduct.price.toFixed(2) }}</b></div>
          <div class="row"><span>运费</span><b>¥0.00</b></div>
          <div class="total"><span>实付</span><b><small>¥</small>{{ curProduct.price.toFixed(2) }}</b></div>
        </div>
      </section>
      <form class="form-card" @submit.prevent="onSubmitForm">
        <h2>收货人信息</h2>
        <div class="field">
          <label for="f-name">收货人<span class="req">*</span></label>
          <input id="f-name" v-model.trim="form.name" type="text" maxlength="20" autocomplete="name" placeholder="请输入收货人姓名" :class="{ invalid: errors.name }">
          <p class="err" :class="{ show: errors.name }">{{ errors.name }}</p>
        </div>
        <div class="field">
          <label for="f-phone">手机号码<span class="req">*</span></label>
          <input id="f-phone" :value="form.phoneRaw" @input="onPhoneInput" type="tel" maxlength="11" inputmode="numeric" autocomplete="tel" placeholder="请输入 11 位手机号" :class="{ invalid: errors.phone }">
          <p class="err" :class="{ show: errors.phone }">{{ errors.phone }}</p>
        </div>
        <div class="field">
          <label>所在地区<span class="req">*</span></label>
          <div class="region-row">
            <select v-model="form.province" aria-label="省份" @change="onProvChange">
              <option value="">请选省</option>
              <option v-for="(citys, prov) in regions" :key="prov" :value="prov">{{ prov }}</option>
            </select>
            <select v-model="form.city" aria-label="城市" :disabled="!form.province" @change="onCityChange">
              <option value="">市</option>
              <option v-for="city in cityOptions" :key="city" :value="city">{{ city }}</option>
            </select>
            <select v-model="form.district" aria-label="区县" :disabled="!form.city || !districtOptions.length" @change="clearRegionError">
              <option value="">区/县</option>
              <option v-for="dist in districtOptions" :key="dist" :value="dist">{{ dist }}</option>
            </select>
          </div>
          <p class="err" :class="{ show: errors.region }">{{ errors.region }}</p>
        </div>
        <div class="field">
          <label for="f-detail">详细地址<span class="req">*</span></label>
          <textarea id="f-detail" v-model.trim="form.detail" maxlength="60" placeholder="街道、门牌号、楼栋单元等详细信息" :class="{ invalid: errors.detail }"></textarea>
          <p class="err" :class="{ show: errors.detail }">{{ errors.detail }}</p>
        </div>
      </form>
      <div class="paybar">
        <div class="paybar-info">
          <span class="paybar-label">合计</span>
          <span class="paybar-price">¥0.01</span>
          <span class="paybar-post">包邮</span>
        </div>
        <button class="btn-pay" @click="openPay">立即支付</button>
      </div>
    </section>

    <!-- ================= 视图三：支付成功 ================= -->
    <section class="view" :class="{ active: currentView === 'success' }">
      <div class="success-wrap">
        <div class="success-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
        </div>
        <h1>支付成功</h1>
        <p class="success-sub">您已用 1 分钱购得心仪好物</p>
        <div class="success-card" v-if="curProduct">
          <img :src="getProductImg(curProduct.id)" alt="商品图">
          <div>
            <b>{{ curProduct.name }}</b>
            <span>收货地址：{{ getAddressText() }}</span>
          </div>
        </div>
        <div class="success-tips">
          商家将在 1-3 个工作日内发货，请您保持手机畅通，留意收货通知。
        </div>
        <button class="btn-primary" @click="goToZone">返回专区继续选购</button>
      </div>
    </section>

    <!-- ================= 云闪付收银台弹层 ================= -->
    <div class="modal-mask" v-show="payModalVisible" @click.self="closePay">
      <div class="sheet">
        <div class="sheet-head">
          <h3>云闪付收银台</h3>
          <button class="sheet-close" aria-label="关闭" @click="closePay">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>
          </button>
        </div>
        <div class="sheet-amount">
          <small>应付金额（元）</small>
          <b>¥0.01</b>
        </div>
        <div class="pay-timer" :class="{ warn: countdown <= 60 }">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9.2"/><path d="M12 7v5l3.2 2"/></svg>
          <span>请在</span><b>{{ countdownText }}</b><span>内完成支付，超时订单将自动取消</span>
        </div>

        <div class="pay-method">
          <span class="pm-icon">
            <svg viewBox="0 0 24 24" fill="#fff"><rect x="2" y="5" width="20" height="14" rx="2.5"/><rect x="5.5" y="9" width="5" height="3" fill="#2E6BFF"/><path d="M14 14h4.5" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/></svg>
          </span>
          <span class="pm-name">银联云闪付</span>
          <span class="pm-tag">推荐</span>
          <svg class="pm-check" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
        </div>
        <button class="btn-confirm" @click="confirmPay">确认支付 ¥0.01</button>
        <button class="btn-cancel" @click="closePay">暂不支付</button>
        <p class="sheet-note">确认后将唤起云闪付H5支付</p>
      </div>
    </div>

    <!-- 活动细则弹窗 -->
<div class="modal-mask rule-mask" v-show="ruleModalVisible" @click.self="closeRuleModal">
  <div class="sheet rule-sheet">
    <div class="sheet-head">
      <h3>活动细则</h3>
      <button class="sheet-close" aria-label="关闭" @click="closeRuleModal">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">
          <path d="M18 6 6 18M6 6l12 12"/>
        </svg>
      </button>
    </div>
    <!-- 重点：增加 rule-scroll 容器，用来滚动文本 -->
    <div class="rule-scroll">
      <div class="rule-body">
        <div class="rule-title">甲子商城“一分购养老用品”权益服务细则</div>
        <dl class="faq-item">
          <dt>一、权益简介</dt>
          <dd>邮储银行银联借记卡指定持卡人（满足邮储银行养老金融示范网点专属见面礼活动条件并且已领取本项权益的客户）可享受甲子商城“一分购养老用品”服务。</dd>
        </dl>
        <dl class="faq-item">
          <dt>二、权益发放对象</dt>
          <dd>邮储银行银联借记卡指定持卡人（满足邮储银行养老金融示范网点专属见面礼活动条件并且已领取本项权益的客户）</dd>
        </dl>
        <dl class="faq-item">
          <dt>三、权益发放时间</dt>
          <dd>即日起至2026年11月30日。</dd>
        </dl>
        <dl class="faq-item">
          <dt>四、服务详情</dt>
          <dd>活动期间，权益发放对象每月可领取1次甲子商城“一分购养老用品”服务，并通过服务商页面享受相关服务，具体权益以服务商页面展示为准。</dd>
        </dl>
        <dl class="faq-item">
          <dt>更多条款及细则</dt>
          <dd>
            <p>1.满足条件的邮储银行银联借记卡指定持卡人可在“邮储银行手机银行APP‑养老金融专区”、“邮储银行手机银行APP‑活动专区”等入口的“养老金融示范网点专属见面礼活动”活动页面参与活动、查看领奖资格以及查看中奖情况；可通过“养老金融示范网点专属见面礼活动”活动页面“我的奖品”或“邮储银行手机银行APP‑我的‑卡券中心”查询服务入口及服务订单。</p>
            <p>2.持卡人领取权益资格后进入服务商页面进行使用，使用流程详见服务商页面，最终使用结果以服务商通知为准。</p>
            <p>3.本权益仅适用于邮储银行银联借记卡指定持卡人（满足邮储银行养老金融示范网点专属见面礼活动条件并且已领取本项权益的客户）。符合同一注册手机号、同一银行卡预留手机号、同一银行实体卡号、同一身份证号、同一云闪付账户等任一条件的均视为同一用户。</p>
            <p>4.本权益有效期为用户领取权益资格后1年内有效，用户需在权益有效期内根据服务商页面说明进行使用，具体使用限制详见权益服务提供方页面。</p>
            <p>5.本权益无需预约，实际兑换使用流程请点击侧边按钮“使用流程”。</p>
            <p>6.如持卡人发生任何违法交易、欺诈交易，或持卡人账户发生拖欠或呈现不正常状态（如：销户、冻结、挂失、进入黑名单等），或持卡人在活动期间申请销卡，中国银联保留拒绝该等持卡人使用本权益。</p>
            <p>7.为使更多的持卡人享到本活动优惠权益，对使用或涉嫌使用违反活动规则或不正当方式套取银联优惠的用户及其所使用的工具，包括但不限于手机号、银行卡号、APP账号等，中国银联和服务商有权不予优惠、追回已发放的优惠,并拒绝其今后参加银联的任何优惠活动。</p>
            <p>8.本权益服务提供方为甲子商城，具体服务流程以甲子商城为准。用户领取权益则视为同意甲子商城服务流程。因各城市机构的差异性而产生的不适用上述细则的情况，以实际情况为准，具体情况请与服务提供方确认。</p>
            <p>9.如持卡人关于甲子商城“一分购养老用品”等相关专业性问题咨询、投诉、建议，可直接致电服务商热线400‑998‑9999（该客服热线以服务商页面展示为准）。如需咨询权益资格领取相关问题，可致电中国银联贵宾服务专线4006295516。</p>
            <p>用户参与活动即视为理解并同意本活动细则。本次活动所有时间点以中国银联后台系统时间为准。在法律许可的范围内，银联保留调整、暂停和终止本活动的权利，并经公告后生效。</p>
            <p>10.持卡人同意并授权中国银联向服务提供方甲子商城及其服务商提供其手机号，从权益供应商处获取权益使用时间、数量，用于为持卡人提供权益及处理投诉。信息采集周期以每次活动公告周期保持一致。用户如需停止信息授权，请在权益平台解绑报名卡片，并停止享受本权益。</p>
            <p>11.持卡人应自行决定是否使用甲子商城该商户提供的商品或服务，中国邮政储蓄银行仅提供借记卡支付服务，本活动中相关商品及服务由活动商户甲子商城提供。持卡人线上实际付款金额如需发票(优惠部分不开发票)、因商品或服务质量引发的任何索赔、质询及投诉由活动商户负责处理和解决。</p>
          </dd>
        </dl>
      </div>
    </div>
    <button class="btn-cancel rule-close-btn" @click="closeRuleModal">知道了</button>
  </div>
</div>


  </div>
</template>
<script>
import { Toast, Indicator } from "mint-ui";
import { REGIONS } from "../../util/Jzuniaddress";
import { qygoodlist,qychktk,qybuy1,qybuy2,qybuypay,qybuycancel} from "../../api/uniqyOrderH5";

export default {
  name: "uniorderh5",
  data() {
    return {
      currentView: 'zone',          // 当前视图: zone / address / success
      products:[],           // 商品配置数据
      curProduct: null,             // 当前选中商品
      faqOpen: false,               // 活动说明展开状态
      payModalVisible: false,       // 支付弹层显示状态
      form: {
        name: '',                   // 收货人姓名
        phoneRaw: '',               // 手机号(原始输入)
        province: '',               // 省份
        city: '',                   // 城市
        district: '',               // 区县
        detail: ''                  // 详细地址
      },
      errors: {
        name: '',                   // 姓名校验错误
        phone: '',                  // 手机校验错误
        region: '',                 // 地区校验错误
        detail: ''                  // 地址校验错误
      },
      regions: REGIONS,             // 省市县数据
      cityOptions: [],              // 城市列表
      districtOptions: [],           // 区县列表
      token: this.$route.query.token ? this.$route.query.token : 0, //从路由中获取变量token传入值
      qbackUrl: "", //权益平台跳转返回地址变量
      sel_gid:0,//当前购买产品id
      member_id:0,//准备购买产品用户id
      order_sn:0,//下单成功单号
      pay_sn:0,  //下单成功支付单号
      countdown: 0,            // 支付倒计时（秒），下单成功后为 600
      countdownTimer: null,    // 倒计时定时器句柄
      ruleModalVisible: false, // 活动细则弹窗显示
    };
  },
  computed:{
     // 倒计时显示为 MM:SS（600 -> 10:00）
    countdownText: function() {
      var m = Math.floor(this.countdown / 60);
      var s = this.countdown % 60;
      return (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
    }
  },
  methods: {
    openRuleModal() {
  this.ruleModalVisible = true
},
closeRuleModal() {
  this.ruleModalVisible = false
},
    /**
     * XSS 转义函数（模板插值 {{ }} 已自带转义，此方法现保留备用）
     */
    esc: function(s) {
      return String(s).replace(/[&<>"']/g, function(c) {
        return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]);
      });
    },
    /**
     * 根据商品ID获取图片URL
     */
    getProductImg: function(id) {
      var p = this.products.find(function(x) { return x.id === id; });
      return p ? p.img : '';
    },
    /**
     * 切换活动说明展开/收起
     */
    toggleFaq: function() {
      this.faqOpen = !this.faqOpen;
    },
    /**
     * 返回专区视图
     */
    goToZone: function() {
      this.currentView = 'zone';
      window.location.hash = '#/zone';
      window.scrollTo(0, 0);
    },
    /**
     * 购买商品 - 选中商品并跳转地址页
     */
    async buyProduct(id) {
      //清理上一笔订单
      this.clearCountdown();
      this.order_sn = 0;
      this.pay_sn = 0;

      //首先加载注册用户数据
       Indicator.open();
       let res = await qybuy1(this.token);
       Indicator.close();
       //console.log(res);
       //console.log(id);
       if(res.data.respCd=="100001"){
           Toast(res.data.respMsg);
           return false;
       }
       else{
          this.member_id=res.data.member_id;
          this.sel_gid=id;  
          var product = this.products.find(function(x) { return x.id === id; });
          if (!product) return;
          if (product.stock <= 0) {
            Toast('该商品已售罄，请看看其他好物');
            return;
          }
          this.curProduct = product;
          this.currentView = 'address';
          window.location.hash = '#/address';
          window.scrollTo(0, 0);
          // 重置表单
          this.form = { name: '', phoneRaw: '', province: '', city: '', district: '', detail: '' };
          this.errors = { name: '', phone: '', region: '', detail: '' };
          this.cityOptions = [];
          this.districtOptions = [];
       }
    },
    /**
     * 省份变化 - 联动加载城市
     */
    onProvChange: function() {
      this.form.city = '';
      this.form.district = '';
      this.cityOptions = [];
      this.districtOptions = [];
      if (!this.form.province) return;
      var citys = Object.keys(this.regions[this.form.province]);
      this.cityOptions = citys;
    },
    /**
     * 城市变化 - 联动加载区县
     */
    onCityChange: function() {
      this.form.district = '';
      this.districtOptions = [];
      if (!this.form.province || !this.form.city) return;
      var dists = this.regions[this.form.province][this.form.city] || [];
      this.districtOptions = dists;
    },
    /**
     * 区县变化 - 清除地区错误提示
     */
    clearRegionError: function() {
      this.errors.region = '';
    },
    /**
     * 手机号输入处理 - 只允许数字
     */
    onPhoneInput: function(e) {
      this.form.phoneRaw = e.target.value.replace(/\D/g, '');
      this.errors.phone = '';
    },
    /**
     * 获取地址文本
     */
    getAddressText: function() {
      var dist = this.form.district ? ' ' + this.form.district : '';
      return this.form.province + ' ' + this.form.city + dist + ' ' + this.form.detail;
    },
    /**
     * 表单提交（输入框回车触发）- 校验并打开支付
     */
    onSubmitForm: function() {
      this.openPay();
    },
    /**
     * 表单校验
     * @returns {boolean} 校验是否通过
     */
    validate: function() {
      var ok = true;
      var name = this.form.name.trim();
      var phone = this.form.phoneRaw.trim();
      var prov = this.form.province;
      var city = this.form.city;
      var dist = this.form.district;
      var detail = this.form.detail.trim();
      if (!name) { this.errors.name = '请填写收货人姓名'; ok = false; }
      else { this.errors.name = ''; }
      if (!/^1[3-9]\d{9}$/.test(phone)) { this.errors.phone = '请填写正确的 11 位手机号'; ok = false; }
      else { this.errors.phone = ''; }
      if (!prov || !city || !dist) {
        this.errors.region = '请选省、市和区县';
        ok = false;
      } else {
        this.errors.region = '';
      }
      if (detail.length < 5) { this.errors.detail = '请填写详细地址（至少 5 个字）'; ok = false; }
      else { this.errors.detail = ''; }
      return ok;
    },
    /**
     * 打开支付弹层
     */
    async openPay() {
      if (!this.validate()) {
        Toast('请先完善收货信息');
        return;
      }
      if (this.order_sn && this.pay_sn) {
        this.payModalVisible = true;
        return;
      }
      //进行下单操作
      var self = this;
      var reciver_name=this.form.name;
      var phone=this.form.phoneRaw;
      var address=this.form.province+this.form.city+this.form.district+this.form.detail;
      Indicator.open({ text: '数据载入中...' });
      let res = await qybuy2(this.token,this.member_id,this.sel_gid,reciver_name,phone,address);
      Indicator.close();
      if(res.data.respCd=="100001"){
         Toast(res.data.respMsg);
         self.currentView = 'address';
         window.location.hash = '#/address';
         window.scrollTo(0, 0);
      }
      else{//下单成功
         this.order_sn=res.data.order_sn;
         this.pay_sn=res.data.pay_sn;
         this.payModalVisible = true;
         this.startCountdown();
         return;
      }
    },
    /**
     * 关闭支付弹层
     */
    closePay: function() {
      this.payModalVisible = false;
      // 订单保留至倒计时结束，明确告知用户
      if (this.countdown > 0) {
        Toast('订单已保留 ' + this.countdownText + '，请及时完成支付');
      }

    },
    //确认支付函数
    async confirmPay() {
       let that=this;
       Indicator.open({ text: '数据载入中...' });
       let res = await qybuypay(this.pay_sn,this.member_id);
       Indicator.close();
       if(res.data.code=="10000"){//发起成功,测试环境默认支付回调
           console.log(res);
           this.clearCountdown();
           /*测试使用
           Toast('支付成功');
           setTimeout(() => {
            window.location.href ="/jzuniqy/unipayreturn?order_sn="+that.order_sn+"&pay_sn="+that.pay_sn;
           }, 1000);*/
           window.location.href=res.data.result;
           return;
       }
       else{
          this.clearCountdown();
          Toast(res.data.message);
          this.payModalVisible = false;
          this.currentView = 'zone';
          window.location.hash = '#/zone';
          window.scrollTo(0, 0);
          return false;
       }
    },
    /**
     * 路由监听 - 处理 hash 变化
     */
    handleRoute: function() {
      var h = window.location.hash || '#/zone';
      if (h === '#/address') {
        if (!this.curProduct) {
          window.location.hash = '#/zone';
          return;
        }
        this.currentView = 'address';
      } else if (h === '#/success') {
        if (!this.curProduct) {
          window.location.hash = '#/zone';
          return;
        }
        this.currentView = 'success';
      } else {
        window.location.hash = '#/zone';
        this.currentView = 'zone';
      }
      window.scrollTo(0, 0);
    },
    //加载产品数据
    async goodinit(){
      let res = await qygoodlist();
      if(res.data.code=="10000"){
         this.products=res.data.result;
      }
    },
    //初始化数据
    async initialize(){
       Indicator.open();
       let res = await qychktk(this.token);
       Indicator.close();
       if(res.data.code=="10001"){
          Toast(res.data.message);
          setTimeout(() => {
            window.location.href ="/home/index";
          }, 1000);
       }
       else{
          
          this.qbackUrl=res.data.result.qbackUrl;
          this.goodinit();
       }
    },
        /**
     * 下单成功后启动 10 分钟支付倒计时
     */
    startCountdown: function() {
      this.clearCountdown();
      this.countdown = 600;
      var self = this;
      this.countdownTimer = setInterval(function() {
        self.countdown--;
        if (self.countdown <= 0) {
          self.autoCancelOrder();
        }
      }, 1000);
    },
    /**
     * 清理倒计时
     */
    clearCountdown: function() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    /**
     * 倒计时结束自动取消订单
     */
    autoCancelOrder: async function() {
      this.clearCountdown();
      this.countdown = 0;
      let that=this;
      Indicator.open({ text: '超时订单取消中...' });
      let res = await qybuycancel(this.order_sn,this.pay_sn,this.member_id);
      Indicator.close();
      if(res.data.code=="10000"){
          Toast('订单超时未支付，已自动取消');
          this.payModalVisible = false;
          this.currentView = 'zone';
          window.location.hash = '#/zone';
          window.scrollTo(0, 0);
          this.order_sn = 0;
          this.pay_sn = 0;
          this.curProduct = null;
      }
      else{
          Toast(res.data.message);
          return false;
      }
      
    },

  },
  created: function() {
    // 页面初始化 - 监听路由变化
    var self = this;
    window.addEventListener('hashchange', function() {
      self.handleRoute();
    });
    this.handleRoute();
    this.initialize();//初始化数据
  },
  beforeDestroy: function() {
    this.clearCountdown();
  }
};
</script>
<style lang='scss'>
/* ===== 全局基础样式（必须不带 scoped） =====
   scoped 会给选择器追加 [data-v-xxx]，导致 :root / html / body 不再命中真实文档：
   - :root 失效 → CSS 变量全部未定义 → 所有 var(--xxx) 的颜色、背景丢失
     （红 hero、米色底、卡片描边、按钮红色全部消失，只剩布局生效）
   - body / html 失效 → 页面背景、全局字号、字体不生效
   因此页面级规则放在这个无 scoped 的块里，组件内规则仍在下方 scoped 块 */
:root{
  --red:#C8102E;
  --red-deep:#A50D26;
  --red-dark:#7E0A1E;
  --gold:#E9B44C;
  --gold-deep:#C9922C;
  --gold-light:#F7E5BC;
  --cream:#FDF6EA;
  --card:#FFFFFF;
  --ink:#3A2A1B;
  --ink2:#77674F;
  --ink3:#A6987F;
  --line:#EFE3CF;
  --ok:#2E7D32;
  --warn:#D96C1F;
  --radius:18px;
  --radius-sm:14px;
}
html{font-size:15px}
body{
  margin:0;
  font-family:"Noto Sans SC","PingFang SC","Microsoft YaHei",system-ui,sans-serif;
  background:#E7DFCE;color:var(--ink);line-height:1.6;
}
</style>
<style scoped lang='scss'>
*{box-sizing:border-box;margin:0;padding:0;-webkit-tap-highlight-color:transparent}
button{font-family:inherit;border:none;background:none;cursor:pointer;color:inherit}
input,select,textarea{font-family:inherit;color:var(--ink)}
img{display:block}
:focus-visible{outline:3px solid var(--gold);outline-offset:2px;border-radius:6px}
.app{
  max-width:520px;margin:0 auto;min-height:100vh;
  background:var(--cream);position:relative;overflow-x:hidden;
  box-shadow:0 0 40px rgba(60,40,20,.18);
}
.view{display:none;min-height:100vh;padding-bottom:84px}
.view.active{display:block;animation:viewIn .35s ease both}
@keyframes viewIn{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}
.topbar{
  position:sticky;top:0;z-index:20;display:flex;align-items:center;justify-content:space-between;
  height:56px;padding:0 14px;background:rgba(255,255,255,.97);border-bottom:1px solid var(--line);
}
.brand{display:flex;align-items:center;gap:8px}
.brand-name{font-family:"Noto Serif SC",serif;font-size:17.5px;font-weight:900;color:var(--red);letter-spacing:.5px}
.brand-tag{font-size:12.5px;font-weight:700;color:var(--red);background:var(--gold-light);border:1px solid var(--gold);padding:1px 8px;border-radius:999px}
.icon-btn{
  width:42px;height:42px;display:flex;align-items:center;justify-content:center;border-radius:50%;
  color:var(--ink);transition:background .2s,transform .12s;
}
.icon-btn:active{background:var(--gold-light);transform:scale(.94)}
.topbar-title{font-size:17px;font-weight:700}
.topbar-spacer{width:42px}
.hero{
  position:relative;color:#fff;padding:22px 20px 24px;overflow:hidden;
  background:
    radial-gradient(circle at 85% 12%, rgba(233,180,76,.35) 0, rgba(233,180,76,0) 42%),
    radial-gradient(circle at 8% 92%, rgba(233,180,76,.28) 0, rgba(233,180,76,0) 46%),
    linear-gradient(135deg,var(--red) 0%,var(--red-deep) 58%,var(--red-dark) 100%);
}
.hero::after{
  content:"";position:absolute;right:-40px;top:-40px;width:150px;height:150px;border-radius:50%;
  border:18px solid rgba(255,255,255,.08);
}
.hero-badge{
  display:inline-flex;align-items:center;gap:6px;font-size:13.5px;font-weight:500;letter-spacing:.5px;
  background:rgba(255,255,255,.16);border:1px solid rgba(233,180,76,.7);color:var(--gold-light);
  padding:4px 12px;border-radius:999px;position:relative;z-index:1;
}
.hero-badge svg{width:14px;height:14px}
.hero-title{
  font-family:"Noto Serif SC","Songti SC",serif;font-size:30px;font-weight:900;line-height:1.25;
  letter-spacing:.5px;flex:1;min-width:0;
}
.hero-title .hl{color:var(--gold)}
.hero-main{display:flex;align-items:center;gap:14px;margin:12px 0 6px;position:relative;z-index:1}
.hero-sub{font-size:14px;color:rgba(255,255,255,.92);position:relative;z-index:1;letter-spacing:.5px}
.hero-price{
  flex:none;text-align:center;line-height:1;z-index:1;
  background:var(--gold);color:var(--red-dark);border-radius:14px;padding:8px 12px 10px;
  box-shadow:0 6px 18px rgba(0,0,0,.22);transform:rotate(-3deg);
}
.hero-price small{display:block;font-size:10.5px;font-weight:700;letter-spacing:1.5px;margin-bottom:3px}
.hero-price b{font-size:17px;font-weight:900;font-family:"Noto Serif SC",serif}
.hero-price span{font-size:11.5px;font-weight:700}
.hero {
  position:relative;color:#fff;padding:22px 20px 24px;overflow:hidden;
  background:
    radial-gradient(circle at 85% 12%, rgba(233,180,76,.35) 0, rgba(233,180,76,0) 42%),
    radial-gradient(circle at 8% 92%, rgba(233,180,76,.28) 0, rgba(233,180,76,0) 46%),
    linear-gradient(135deg,var(--red) 0%,var(--red-deep) 58%,var(--red-dark) 100%);
  /* 这里原有样式保留，下面新增 */
}
.hero-rule-btn{
  position: absolute;
  top: 14px;
  right:-6px;
  z-index: 2;
  font-size:13.5px;
  font-weight: 500;
  color:#fff;
  border:1px solid rgba(233, 180, 76,.55);
  border-radius:999px;
  padding:4px 12px;
  /* 浮动玻璃效果 */
  background:rgba(255,255,255,.18);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  box-shadow: 0 4px 12px rgba(0,0,0,.22);
  transition: transform .2s ease,box-shadow .2s ease,background .2s;
}
.hero-rule-btn:active{
  transform: translateY(1px);
  box-shadow: 0 2px 6px rgba(0,0,0,.18);
  background:rgba(233,180,76,.28);
}

.product-list{display:grid;grid-template-columns:1fr 1fr;gap:10px;padding:12px 14px}
.pcard{
  background:var(--card);border:1px solid var(--line);border-radius:var(--radius);
  padding:8px;display:flex;flex-direction:column;
}
.pimg{position:relative;width:100%;aspect-ratio:1/1;border-radius:10px;overflow:hidden;background:#F5F0E4}
.pimg img{width:100%;height:100%;object-fit:cover}
.ptag{
  position:absolute;left:0;top:0;font-size:11.5px;font-weight:700;color:#fff;
  background:linear-gradient(135deg,var(--gold),var(--gold-deep));padding:2px 8px;border-radius:0 0 10px 0;
}
.psold-badge{
  position:absolute;inset:0;display:flex;align-items:center;justify-content:center;
  background:rgba(60,45,30,.46);color:#fff;font-size:14px;font-weight:700;letter-spacing:2px;
}
.pinfo{flex:1;display:flex;flex-direction:column;padding:8px 2px 0}
.pname{
  font-size:15px;font-weight:700;line-height:1.35;color:var(--ink);min-height:40px;
  display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;
}
.pprice{display:flex;align-items:baseline;gap:6px;margin-top:4px;flex-wrap:wrap}
.price-now{font-family:"Noto Serif SC",serif;font-size:19px;font-weight:900;color:var(--red)}
.price-now small{font-size:12px;font-weight:700}
.price-orig{font-size:12px;color:var(--ink3);text-decoration:line-through}
.pstock{margin-top:3px;font-size:13px;color:var(--ink3);font-weight:500}
.pstock.low{color:var(--warn);font-weight:700}
.btn-buy{
  width:100%;min-height:44px;margin-top:8px;border-radius:10px;
  background:linear-gradient(135deg,var(--red),var(--red-deep));color:#fff;
  font-size:15.5px;font-weight:700;letter-spacing:2px;
  transition:transform .12s,box-shadow .2s;box-shadow:0 4px 12px rgba(200,16,46,.28);
}
.btn-buy:active{transform:scale(.98)}
.btn-buy.disabled{background:#D8CFBE;color:#fff;box-shadow:none;cursor:not-allowed}
.faq{margin:6px 14px 0;background:var(--card);border:1px solid var(--line);border-radius:var(--radius);overflow:hidden}
.faq-head{
  width:100%;display:flex;align-items:center;justify-content:space-between;padding:13px 16px;
  font-size:16.5px;font-weight:700;
}
.faq-head svg{width:20px;height:20px;color:var(--ink3);transition:transform .25s}
.faq-item{
  border-top:1px dashed var(--line);padding:12px 16px;
}
.faq-item dt{font-size:14.5px;font-weight:700;color:var(--red-dark);margin-bottom:3px}
.faq-item dd{font-size:13.5px;color:var(--ink2)}
.faq-body{max-height:0;overflow:hidden;transition:max-height .3s ease}
.faq.open .faq-body{max-height:420px}
.faq.open .faq-head svg{transform:rotate(180deg)}
.legal{padding:16px 20px 14px;text-align:center;font-size:12px;color:var(--ink3);line-height:1.8}
.steps{display:flex;align-items:center;justify-content:center;gap:0;padding:14px 14px 6px}
.step{display:flex;flex-direction:column;align-items:center;gap:4px;min-width:68px}
.step i{
  width:32px;height:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;
  font-style:normal;font-weight:700;font-size:15px;background:#E8DDC8;color:var(--ink3);
}
.step span{font-size:13px;color:var(--ink3);white-space:nowrap}
.step.active i{background:var(--red);color:#fff;box-shadow:0 4px 10px rgba(200,16,46,.3)}
.step.active span{color:var(--red);font-weight:700}
.step.done i{background:var(--gold);color:#fff}
.step-line{flex:1;height:2.5px;max-width:56px;margin:0 4px;border-radius:2px;background:#E8DDC8;position:relative;top:-17px}
.step-line.done{background:var(--gold)}
.cd-bar{
  display:flex;align-items:center;justify-content:center;gap:5px;
  margin:10px 14px 0;padding:9px 12px;border-radius:var(--radius-sm);
  background:linear-gradient(135deg,var(--gold),var(--gold-deep));color:#fff;
  font-size:13.5px;font-weight:500;box-shadow:0 3px 10px rgba(201,146,44,.25);
}
.cd-bar svg{width:16px;height:16px;flex:none}
.cd-bar b{font-size:15px;font-weight:800;letter-spacing:.5px}
.order-card{
  margin:12px 14px 0;background:var(--card);border:1px solid var(--line);border-radius:var(--radius);padding:14px;
}
.order-card h2{font-size:16.5px;font-weight:700;margin-bottom:10px}
.order-row{display:flex;align-items:center;gap:12px}
.order-img{width:76px;height:76px;flex:none;border-radius:var(--radius-sm);overflow:hidden;background:#F5F0E4}
.order-img img{width:100%;height:100%;object-fit:cover}
.order-info{flex:1;min-width:0}
.order-name{font-size:16px;font-weight:700;line-height:1.35}
.order-spec{font-size:13.5px;color:var(--ink3);margin-top:2px}
.order-price{text-align:right}
.order-price .now{font-family:"Noto Serif SC",serif;font-size:19px;font-weight:900;color:var(--red)}
.order-price .orig{font-size:12px;color:var(--ink3);text-decoration:line-through;display:block}
.order-meta{border-top:1px dashed var(--line);margin-top:10px;padding-top:10px;display:flex;flex-direction:column;gap:6px;font-size:14.5px}
.order-meta .row{display:flex;justify-content:space-between;color:var(--ink2)}
.order-meta .row b{color:var(--ink)}
.order-meta .total{display:flex;justify-content:flex-end;align-items:baseline;gap:6px;padding-top:3px}
.order-meta .total span{font-size:13.5px;color:var(--ink2)}
.order-meta .total b{font-family:"Noto Serif SC",serif;font-size:22px;font-weight:900;color:var(--red)}
.form-card{
  margin:12px 14px 0;background:var(--card);border:1px solid var(--line);border-radius:var(--radius);
  padding:14px 12px 6px;
}
.form-card h2{font-size:16.5px;font-weight:700;margin-bottom:4px}
.field{margin-bottom:12px}
.field label{display:block;font-size:15px;font-weight:700;margin-bottom:6px}
.field label .req{color:var(--red);margin-left:2px}
.field input,.field textarea,.field select{
  width:100%;min-height:48px;border:1.5px solid #E6D8Be;border-radius:12px;
  background:#FBF6EA;font-size:15.5px;padding:0 14px;transition:border-color .2s,background .2s;
}
.field input::placeholder,.field textarea::placeholder{color:var(--ink3)}
.field input:focus,.field textarea:focus,.field select:focus{outline:none;border-color:var(--red);background:#fff}
.field input.invalid,.field textarea.invalid{border-color:var(--warn);background:#FFF7EF}
.field textarea{min-height:80px;padding:10px 14px;line-height:1.6;resize:none}
.field .err{display:none;font-size:13px;color:var(--warn);margin-top:5px;font-weight:500}
.field .err.show{display:block}
.region-row{display:flex;gap:8px}
.region-row select{flex:1;min-width:0;appearance:none;font-size:15px;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2377674F' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
  background-repeat:no-repeat;background-position:right 8px center;background-size:14px;
  padding:0 18px 0 10px;text-overflow:ellipsis;
}
.region-row select:disabled{color:var(--ink3);background-color:#F3ECDD}
.paybar{
  position:sticky;bottom:0;z-index:20;display:flex;align-items:center;justify-content:space-between;gap:12px;
  padding:10px 14px calc(10px + env(safe-area-inset-bottom));
  background:rgba(255,255,255,.97);border-top:1px solid var(--line);
}
.paybar-info{display:flex;align-items:baseline;gap:8px;min-width:0}
.paybar-label{font-size:13.5px;color:var(--ink2)}
.paybar-price{font-family:"Noto Serif SC",serif;font-size:23px;font-weight:900;color:var(--red)}
.paybar-post{font-size:12px;color:var(--ok);background:#E7F4E7;padding:2px 8px;border-radius:999px;font-weight:700}
.btn-pay{
  flex:none;min-height:50px;padding:0 28px;border-radius:14px;font-size:16.5px;font-weight:700;letter-spacing:2px;
  background:linear-gradient(135deg,var(--red),var(--red-deep));color:#fff;
  box-shadow:0 6px 16px rgba(200,16,46,.32);transition:transform .12s;
}
.btn-pay:active{transform:scale(.98)}
.modal-mask{
  position:fixed;inset:0;z-index:50;background:rgba(30,20,10,.55);
  display:flex;align-items:flex-end;justify-content:center;
}
.modal-mask[hidden],.processing[hidden]{display:none}
.sheet{
  width:100%;max-width:520px;background:#fff;border-radius:22px 22px 0 0;padding:14px 16px calc(20px + env(safe-area-inset-bottom));
  animation:sheetUp .28s ease both;
}
@keyframes sheetUp{from{transform:translateY(60px);opacity:.4}to{transform:none;opacity:1}}
.sheet-head{display:flex;align-items:center;justify-content:space-between;padding-bottom:4px}
.sheet-head h3{font-size:16.5px;font-weight:700}
.sheet-close{width:40px;height:40px;border-radius:50%;display:flex;align-items:center;justify-content:center;color:var(--ink3)}
.sheet-close:active{background:var(--gold-light)}
.sheet-amount{
  text-align:center;padding:6px 0 14px;border-bottom:1px solid var(--line);
}
.sheet-amount small{display:block;font-size:13px;color:var(--ink2);margin-bottom:3px}
.sheet-amount b{font-family:"Noto Serif SC",serif;font-size:34px;font-weight:900;color:var(--ink)}
.pay-timer{
  display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:5px;
  margin-top:10px;font-size:13.5px;color:var(--red-dark);font-weight:500;text-align:center;
}
.pay-timer svg{width:16px;height:16px;flex:none}
.pay-timer b{font-size:14.5px;font-weight:800;letter-spacing:.5px}
.pay-timer.warn{color:var(--warn);font-weight:700}
.pay-method{
  display:flex;align-items:center;gap:12px;margin:14px 0;padding:12px;
  border:2px solid var(--red);border-radius:var(--radius-sm);background:#FFF7F3;
}
.pay-method .pm-icon{
  width:40px;height:40px;border-radius:12px;background:linear-gradient(135deg,#2E6BFF,#0E3FBF);
  display:flex;align-items:center;justify-content:center;flex:none;
}
.pay-method .pm-icon svg{width:24px;height:24px}
.pay-method .pm-name{font-size:15.5px;font-weight:700;flex:1}
.pay-method .pm-tag{font-size:12px;color:var(--red);border:1px solid var(--red);border-radius:999px;padding:1px 7px;font-weight:700}
.pay-method .pm-check{color:var(--red)}
.btn-confirm{
  width:100%;min-height:50px;border-radius:14px;font-size:16.5px;font-weight:700;letter-spacing:2px;
  background:linear-gradient(135deg,var(--red),var(--red-deep));color:#fff;
  box-shadow:0 6px 16px rgba(200,16,46,.32);
}
.btn-cancel{width:100%;min-height:46px;margin-top:10px;border-radius:14px;font-size:15px;color:var(--ink2);background:#F3EDE0}
.sheet-note{text-align:center;font-size:12.5px;color:var(--ink3);margin-top:10px}
.processing{
  position:fixed;inset:0;z-index:51;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;
  background:rgba(255,255,255,.96);color:var(--ink);font-size:16px;font-weight:500;
}
.spinner{width:48px;height:48px;border-radius:50%;border:5px solid var(--gold-light);border-top-color:var(--red);animation:spin .9s linear infinite}
@keyframes spin{to{transform:rotate(360deg)}}
.success-wrap{
  min-height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;
  padding:36px 20px 48px;text-align:center;
}
.success-icon{
  width:80px;height:80px;border-radius:50%;background:linear-gradient(135deg,#34A853,#1E7D3A);
  display:flex;align-items:center;justify-content:center;color:#fff;margin-bottom:16px;
  box-shadow:0 10px 26px rgba(30,125,58,.3);animation:pop .45s cubic-bezier(.2,1.6,.4,1) both;
}
.success-icon svg{width:44px;height:44px}
@keyframes pop{from{transform:scale(.3);opacity:0}to{transform:scale(1);opacity:1}}
.success-wrap h1{font-family:"Noto Serif SC",serif;font-size:24px;font-weight:900}
.success-sub{font-size:14.5px;color:var(--ink2);margin-top:5px}
.success-card{
  width:100%;display:flex;gap:12px;align-items:center;text-align:left;
  background:var(--card);border:1px solid var(--line);border-radius:var(--radius);padding:12px;margin:18px 0 0;
}
.success-card img{width:64px;height:64px;border-radius:12px;object-fit:cover;flex:none;background:#F5F0E4}
.success-card b{display:block;font-size:15.5px;line-height:1.35}
.success-card span{display:block;font-size:13px;color:var(--ink3);margin-top:3px;line-height:1.5}
.success-tips{
  width:100%;margin-top:10px;padding:10px 12px;background:var(--gold-light);border:1px solid var(--gold);
  border-radius:var(--radius-sm);font-size:13.5px;color:var(--red-dark);font-weight:500;text-align:left;
}
.btn-primary{
  width:100%;min-height:50px;margin-top:22px;border-radius:14px;font-size:16.5px;font-weight:700;letter-spacing:2px;
  background:linear-gradient(135deg,var(--red),var(--red-deep));color:#fff;
  box-shadow:0 6px 16px rgba(200,16,46,.32);
}
.toast{
  position:fixed;top:14px;left:50%;transform:translateX(-50%);z-index:60;
  max-width:86vw;
  background:rgba(45,32,20,.92);color:#fff;
  font-size:14.5px;font-weight:500;padding:10px 18px;border-radius:12px;text-align:center;
  opacity:0;pointer-events:none;transition:opacity .25s;
}
.toast.show{opacity:1}
@media (min-width: 512px){
  .toast{ max-width:440px; }
}
@media (prefers-reduced-motion: reduce){
  *{animation:none !important;transition:none !important}
}
.rule-sheet {
  display: flex;
  flex-direction: column;
  max-height: 82vh; /* 弹窗整体最大高度，留出安全区和按钮 */
}
.rule-scroll {
  flex: 1;
  overflow-y: auto; /* 只有文本区域滚动 */
  -webkit-overflow-scrolling: touch; /* ios/云闪付小程序顺滑滚动 */
  padding: 4px 0;
}
.rule-title {
  font-size:17px;
  font-weight:900;
  text-align:center;
  color:var(--red-dark);
  margin-bottom:12px;
}
.rule-body p {
  margin:6px 0;
  line-height:1.7;
  font-size:13.5px;
  color:var(--ink2);
}
.rule-body dd {
  line-height:1.7;
  font-size:13.5px;
  color:var(--ink2);
}
.rule-close-btn {
  margin-top:14px;
  flex: 0 0 auto; /* 按钮固定，不被压缩 */
}


</style>
